(() => {
  'use strict';
  const shuffle = items => {
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };
  async function init() {
    for (const section of document.querySelectorAll('[data-clearance-random]:not([data-random-ready])')) {
      section.dataset.randomReady = 'loading';
      const grid = section.querySelector('.home-catalog-products');
      if (!grid) continue;
      const fallback = [...grid.children];
      grid.replaceChildren(...shuffle(fallback).slice(0, 18));
      const pages = Number(section.dataset.clearancePages) || 1;
      if (pages > 1) {
        const picks = shuffle(Array.from({length: pages}, (_, i) => i + 1)).slice(0, 2);
        const groups = await Promise.all(picks.map(async page => {
          try {
            const url = new URL(location.pathname, location.origin);
            url.searchParams.set('section_id', section.dataset.sectionId);
            url.searchParams.set(section.dataset.clearancePageParam || 'page', page);
            const response = await fetch(url);
            if (!response.ok) return [];
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            return [...doc.querySelectorAll('[data-clearance-random] .gastro-product-card')];
          } catch { return []; }
        }));
        const unique = new Map();
        for (const card of groups.flat()) {
          const href = card.querySelector('a[href]')?.getAttribute('href');
          if (href) unique.set(href, card);
        }
        if (unique.size) grid.replaceChildren(...shuffle([...unique.values()]).slice(0, 18));
      }
      section.dataset.randomReady = 'done';
    }
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
